/**
 * Reads a JSON value from localStorage.
 *
 * @param {String} key - String. The localStorage key.
 *
 * @returns {any} The parsed value, or undefined when the key is missing, empty or holds 'undefined'/'null'.
 */
export default (key) => {
  const stored = localStorage.getItem(key);
  return stored && stored !== 'undefined' && stored !== 'null'
    ? JSON.parse(stored)
    : undefined;
};
